import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "", order_number: "" });
  const [sent, setSent] = useState(null);
  const [busy, setBusy] = useState(false);
  useSeo("Contact client services", "Reach the Maison Éclat client services team.");
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/store/contact", form);
      setSent(r.data);
      toast.success("Message received");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="container-lux pt-8 pb-20" data-testid="contact-page">
      <nav className="text-xs text-muted-foreground mb-6"><Link to="/" className="hover:text-foreground">Home</Link><span className="mx-1.5">/</span><span className="text-foreground">Client services</span></nav>
      <div className="max-w-[720px]">
        <h1 className="font-display text-5xl font-medium">Client services</h1>
        <p className="text-foreground/80 mt-5 leading-relaxed text-lg">We respond within one business day. For order-related enquiries, include the order number so we can help you faster.</p>
        {sent ? (
          <div className="mt-10 bg-white border rounded-lg p-8" data-testid="contact-success">
            <p className="font-display text-3xl">Thank you — we have your message</p>
            <p className="text-sm text-muted-foreground mt-3">Your reference is <span className="tabular font-semibold text-foreground">{sent.reference}</span>. A member of client services will reply to <span className="text-foreground">{form.email}</span> shortly.</p>
            <p className="text-xs text-muted-foreground mt-6" data-testid="contact-email-notice">Our email notification provider is <strong>not configured</strong> yet, so no automated confirmation has been sent — the message is safely stored in our system.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 bg-white border rounded-lg p-6 lg:p-8 space-y-5" data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-4">
              <div><Label htmlFor="c-name">Full name</Label><Input id="c-name" value={form.name} onChange={update("name")} required maxLength={120} data-testid="contact-name-input" /></div>
              <div><Label htmlFor="c-email">Email address</Label><Input id="c-email" type="email" value={form.email} onChange={update("email")} required data-testid="contact-email-input" /></div>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div><Label htmlFor="c-subject">Subject</Label><Input id="c-subject" value={form.subject} onChange={update("subject")} required maxLength={160} data-testid="contact-subject-input" /></div>
              <div><Label htmlFor="c-order">Order number (optional)</Label><Input id="c-order" value={form.order_number} onChange={update("order_number")} maxLength={40} data-testid="contact-order-input" /></div>
            </div>
            <div><Label htmlFor="c-msg">Message</Label><Textarea id="c-msg" value={form.message} onChange={update("message")} required minLength={10} maxLength={4000} rows={6} data-testid="contact-message-input" /></div>
            <button type="submit" disabled={busy} className="btn-ink" data-testid="contact-submit-button">{busy ? "Sending…" : "Send message"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
